import { mapProjectProgressService, ProjectProgressService } from "./ProjectProgressService";

/* **************************************************** Project Progress */
export interface ProjectProgress {
    id: number;
    project_id: number;
    service_id: number;
    job_date: string;
    job_submission_date: string | null;
    application_submitted_date: string | null;
    application_validated: 'Pending' | 'Validated';
    application_validated_date: string | null;
    decision_date: string | null;
    address: string;
    job_number: string;
    service: ProjectProgressService | null;
}

export const mapProjectProgress = (data: any): ProjectProgress => {
    if (!data) {
        throw new Error("Invalid project progress type");
    }

    const res: ProjectProgress = {
        id: data.id,
        project_id: data.project_id,
        service_id: data.service_id,
        job_date: data.job_date,
        job_submission_date: data.job_submission_date ?? null,
        application_submitted_date: data.application_submitted_date ?? null,
        application_validated: data.application_validated,
        application_validated_date: data.application_validated_date ?? null,
        decision_date: data.decision_date ?? null,
        address: data.address,
        job_number: data.job_number,
        service: data.service ? mapProjectProgressService(data.service) : null,
    };

    return res;
};

export const mapProjectProgresses = (data: any[]): ProjectProgress[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid project progress data");
    }

    return data.map(mapProjectProgress);
};
/* **************************************************** */